var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13453_9893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.83519 3.95894H3.11496C3.56492 5.61448 5.27174 6.5918 6.92728 6.14185C7.99057 5.85285 8.82119 5.02223 9.11019 3.95894H19.1667C19.6269 3.95894 19.9999 3.58589 19.9999 3.1257C19.9999 2.66552 19.6269 2.29247 19.1667 2.29247H9.11019C8.66023 0.636889 6.95341 -0.340435 5.29787 0.10952C4.23458 0.398514 3.40396 1.22913 3.11496 2.29243H0.83519C0.375002 2.29243 0.00195312 2.66548 0.00195312 3.12566C0.00195312 3.58585 0.375002 3.95894 0.83519 3.95894Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 9.16675H16.8869C16.4379 7.51145 14.732 6.53358 13.0767 6.9826C12.0125 7.27128 11.1812 8.10256 10.8925 9.16675H0.83519C0.375002 9.16675 0.00195312 9.5398 0.00195312 9.99999C0.00195312 10.4602 0.375002 10.8332 0.83519 10.8332H10.8925C11.3416 12.4885 13.0475 13.4664 14.7028 13.0174C15.7669 12.7287 16.5982 11.8974 16.8869 10.8332H19.1667C19.6269 10.8332 19.9999 10.4602 19.9999 9.99999C19.9999 9.5398 19.6269 9.16675 19.1667 9.16675Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 16.0411H9.11019C8.66023 14.3855 6.95341 13.4082 5.29787 13.8581C4.23458 14.1471 3.40396 14.9778 3.11496 16.0411H0.83519C0.375002 16.0411 0.00195312 16.4141 0.00195312 16.8743C0.00195312 17.3345 0.375002 17.7075 0.83519 17.7075H3.11496C3.56492 19.3631 5.27174 20.3404 6.92728 19.8904C7.99057 19.6014 8.82119 18.7708 9.11019 17.7075H19.1667C19.6269 17.7075 19.9999 17.3345 19.9999 16.8743C19.9999 16.4141 19.6269 16.0411 19.1667 16.0411Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13453_9893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.3d4ff1e333b6f3d1c91f3ca8d39e8e0d.svg";
export { ForwardRef as ReactComponent };